import styles from '../tipselectionwizard.module.css'

import type { PipetteShadowProps } from '../types'

export function EightChannelOT2Shadow(props: PipetteShadowProps): JSX.Element {
  const { x, y, width, height, fill, stroke } = props
  return (
    <svg
      width={width}
      height={height}
      x={x}
      y={y}
      viewBox="0 0 101 272"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.shadow_overlay}
      fill={fill}
      stroke={stroke}
      strokeWidth="2.7881"
    >
      <path
        d="M57.5303 1.39453C72.8778 6.76301 83.8867 21.3692 83.8867 38.5488V232.856C83.8866 250.035 72.8787 264.641 57.5322 270.01H27.75C12.4033 264.641 1.3947 250.035 1.39453 232.856V38.5488C1.39453 21.369 12.4042 6.76286 27.752 1.39453H57.5303Z"
        fill={fill}
      />
      <path
        d="M57.5303 1.39453L57.9909 0.0777647L57.7672 -0.000468731H57.5303V1.39453ZM83.8867 232.856L85.2817 232.856V232.856H83.8867ZM57.5322 270.01V271.405H57.7692L57.9929 271.327L57.5322 270.01ZM27.75 270.01L27.2894 271.327L27.513 271.405H27.75V270.01ZM1.39453 232.856H-0.000468731V232.856L1.39453 232.856ZM27.752 1.39453V-0.000468731H27.515L27.2914 0.0777582L27.752 1.39453ZM57.5303 1.39453L57.0697 2.7113C71.8751 7.89016 82.4917 21.9805 82.4917 38.5488H83.8867H85.2817C85.2817 20.7579 73.8804 5.63586 57.9909 0.0777647L57.5303 1.39453ZM83.8867 38.5488H82.4917V232.856H83.8867H85.2817V38.5488H83.8867ZM83.8867 232.856L82.4917 232.856C82.4916 249.424 71.876 263.514 57.0716 268.693L57.5322 270.01L57.9929 271.327C73.8814 265.768 85.2816 250.647 85.2817 232.856L83.8867 232.856ZM57.5322 270.01V268.615H27.75V270.01V271.405H57.5322V270.01ZM27.75 270.01L28.2106 268.693C13.406 263.514 2.78969 249.424 2.78953 232.856L1.39453 232.856L-0.000468731 232.856C-0.00029552 250.647 11.4006 265.768 27.2894 271.327L27.75 270.01ZM1.39453 232.856H2.78953V38.5488H1.39453H-0.000468731V232.856H1.39453ZM1.39453 38.5488H2.78953C2.78953 21.9803 13.4068 7.89003 28.2125 2.7113L27.752 1.39453L27.2914 0.0777582C11.4016 5.63568 -0.000468731 20.7577 -0.000468731 38.5488H1.39453ZM27.752 1.39453V2.78953H57.5303V1.39453V-0.000468731H27.752V1.39453Z"
        fill={fill}
      />
      <path
        d="M83.8867 67.2402H87.0867C93.8841 67.2402 99.3944 72.7506 99.3944 79.5479V191.856C99.3944 198.653 93.8841 204.163 87.0867 204.163H83.8867V67.2402Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="2.79"
      />
    </svg>
  )
}
